import React, { useRef } from "react";

export function ImageScannerHiddenInput({
  onFileScanned,
}: {
  onFileScanned: (file: File) => void | Promise<void>;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  const trigger = () => {
    inputRef.current?.click();
  };

  return {
    trigger,
    input: (
      <input
        ref={inputRef}
        className="hidden"
        type="file"
        capture="environment"
        accept="image/*"
        onChange={async (e) => {
          const files = e.target.files;
          if (files && files.length > 0) {
            const file = files.item(0);
            if (file) {
              onFileScanned(file);
            }
          }
          // Reset value to allow scanning the same file again if needed
          if (e.target) {
            e.target.value = "";
          }
        }}
      />
    ),
  };
}